import { Accessor, createSignal } from "solid-js";

export function useCampaignSelection(max: Accessor<number>) {
  const [selectedIds, setSelectedIds] = createSignal<Set<string>>(new Set());

  const isSelected = (id: string) => selectedIds().has(id);
  const canSelectMore = () => selectedIds().size < max();

  const toggleSelection = (id: string, isNowSelected: boolean) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (isNowSelected) {
        next.add(id);
      } else {
        next.delete(id);
      }
      return next;
    });
  };

  return { selectedIds, isSelected, canSelectMore, toggleSelection };
}
